import { makeStyles } from "tss-react/mui";

export const useAttributeRowStyles = makeStyles()((theme) => ({
  root: {
    height: 60,
    borderRadius: 12,
    backgroundColor: theme.palette.grey[700],
  },
}));
